export const PAGE_404_PATH = "/page-not-found";
